<template>
    <v-btn class="btn-right"
            color="secondary"
            @click="$emit('click')"
           :disabled="disabled"
           :loading="loading"
    >
        <slot>Weiter</slot>
    </v-btn>
</template>

<script>
    export default {
        name: "ButtonNext",
        props: {
            disabled: Boolean,
            loading: Boolean
        }
    }
</script>

<style scoped>
</style>